import SubHeader from './SubHeader';
import PageHeader from './PageHeader';
import type { SubheaderType } from './SubHeader';
import type {
  IPageHeaderProps,
  IBreadcrumbItem,
  IHeaderTab,
} from './PageHeader';

export { SubHeader, PageHeader };
export type { SubheaderType, IPageHeaderProps, IBreadcrumbItem, IHeaderTab };

export default SubHeader;
